import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import jwt_decode from "jwt-decode";
import CryptoJS from "crypto-js";
import "./leftSidebar.css";

const LeftSidebar = () => {
  const [profileOpen, setProfileOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const logoutUser = () => {
    localStorage.removeItem("jwtToken");
    window.location.replace("/");
  };

  const token = localStorage.getItem("jwtToken");
  const decodedToken = jwt_decode(token);
  const userInfo = decodedToken;
  const user_id = userInfo.user_id;

  const secretKey = "Maxx12#";
  const encryptUserId = (userId) => {
    const encrypted = CryptoJS.AES.encrypt(userId, secretKey).toString();
    return encrypted
      .replace(/\//g, "_")
      .replace(/\+/g, "-")
      .replace(/=/g, "");
  };
  const encryptedUserId = encryptUserId(user_id);

  // Auto-open Profile submenu if current path is one of its children
  useEffect(() => {
    const profilePaths = ["/profile-manage", "/password-manage", "/tpin-manage"];
    if (profilePaths.includes(location.pathname)) {
      setProfileOpen(true);
    }
  }, [location.pathname]);

  // Close mobile drawer on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const onNavClick = () => {
    if (mobileOpen) setMobileOpen(false);
  };

  // Returns active class if pathname matches
  const navClass = (path) =>
    `lsb-item${location.pathname === path ? " active" : ""}`;

  const downlineActive = location.pathname === `/down-list/${encryptedUserId}`;

  const profileActive = ["/profile-manage", "/password-manage", "/tpin-manage"].includes(
    location.pathname
  );

  return (
    <>
      {/* ── Mobile hamburger button ── */}
      <button
        className="lsb-toggle"
        onClick={() => setMobileOpen((prev) => !prev)}
        aria-label={mobileOpen ? "Close menu" : "Open menu"}
      >
        <i className="material-icons">{mobileOpen ? "close" : "menu"}</i>
      </button>

      {/* ── Mobile backdrop overlay ── */}
      <div
        className={`lsb-overlay ${mobileOpen ? "visible" : ""}`}
        onClick={() => setMobileOpen(false)}
      />

      {/* ── Sidebar ── */}
      <div className={`lsb ${mobileOpen ? "open" : ""}`}>

        {/* Logo */}
        <div className="lsb-logo">
          <div className="lsb-logo-icon">BJ</div>
          <div className="lsb-logo-name">
            <span>dicebd</span>
          </div>
        </div>

        {/* User info */}
        <div className="lsb-user">
          <div className="lsb-avatar">MA</div>
          <div style={{ minWidth: 0 }}>
            <div className="lsb-uname">Master Admin</div>
            <div className="lsb-urole">{userInfo.user_id}</div>
          </div>
        </div>

        {/* Nav */}
        <div className="lsb-scroll">

          {/* ── Main ── */}
          <div className="lsb-section">Main</div>

          <Link className={navClass("/admin")} to="/admin" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>dashboard</i>
            </div>
            <span className="lsb-label">Master Admin Dashboard</span>
          </Link>

          {/* ── Finance ── */}
          <div className="lsb-section">Finance</div>

          <Link className={navClass("/agent-balance-report")} to="/agent-balance-report" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>swap_horiz</i>
            </div>
            <span className="lsb-label">Balance Transfer</span>
          </Link>

          <Link className={navClass("/daily-deposit")} to="/daily-deposit" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>arrow_downward</i>
            </div>
            <span className="lsb-label">Daily Deposit List</span>
          </Link>

          <Link className={navClass("/daily-withdraw")} to="/daily-withdraw" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>arrow_upward</i>
            </div>
            <span className="lsb-label">Daily Withdraw List</span>
          </Link>

          <Link className={navClass("/rebate-list")} to="/rebate-list" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>receipt_long</i>
            </div>
            <span className="lsb-label">Rebate Commission</span>
          </Link>

          <Link className={navClass("/loss-bonus")} to="/loss-bonus" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>trending_down</i>
            </div>
            <span className="lsb-label">Loss Bonus Commission</span>
          </Link>

          {/* ── Management ── */}
          <div className="lsb-section">Management</div>

          <Link className={navClass("/agent-index")} to="/agent-index" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>admin_panel_settings</i>
            </div>
            <span className="lsb-label">Admin List</span>
          </Link>

          <Link className={navClass("/super-agent")} to="/super-agent" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>supervisor_account</i>
            </div>
            <span className="lsb-label">Super Agent List</span>
          </Link>

          <Link className={navClass("/master-agent")} to="/master-agent" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>people</i>
            </div>
            <span className="lsb-label">Affiliate Agent List</span>
          </Link>

          <Link className={navClass("/user-index")} to="/user-index" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>group</i>
            </div>
            <span className="lsb-label">User List</span>
          </Link>
          
          <Link className={navClass("/casino-summery")} to="/casino-summery" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>group</i>
            </div>
            <span className="lsb-label">Bet Report</span>
          </Link>
            
          <Link className={navClass("/baji-challange")} to="/baji-challange" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>group</i>
            </div>
            <span className="lsb-label">Baji Challange</span>
          </Link>       
          
          <Link className={navClass("/refferal-achievement")} to="/refferal-achievement" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>group</i>
            </div>
            <span className="lsb-label">Refferal Achievement</span>
          </Link>
          
          {/* 
          <Link
            className={`lsb-item${downlineActive ? " active" : ""}`}
            to={`/down-list/${encryptedUserId}`}
            onClick={onNavClick}
          >
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>account_tree</i>
            </div>
            <span className="lsb-label">Downline List</span>
          </Link> */}


          {/* ── Content ── */}
          <div className="lsb-section">Content</div>

          <Link className={navClass("/notice-manage")} to="/notice-manage" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>notifications</i>
            </div>
            <span className="lsb-label">Notice Manage</span>
          </Link>

          <Link className={navClass("/slide-manage")} to="/slide-manage" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>view_carousel</i>
            </div>
            <span className="lsb-label">Slide Manage</span>
          </Link>

          <Link className={navClass("/promotion")} to="/promotion" onClick={onNavClick}>
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>campaign</i>
            </div>
            <span className="lsb-label">Promotion Manage</span>
          </Link>

          {/* ── Settings ── */}
          <div className="lsb-section">Settings</div>

          {/* Profile dropdown — shows active if any child route is active */}
          <div
            className={`lsb-item${profileActive ? " active" : ""}`}
            onClick={() => setProfileOpen((prev) => !prev)}
            style={{ cursor: "pointer" }}
            role="button"
            aria-expanded={profileOpen}
          >
            <div className="lsb-icon">
              <i className="material-icons" style={{ fontSize: "16px" }}>manage_accounts</i>
            </div>
            <span className="lsb-label">Profile Manage</span>
            <i
              className="material-icons"
              style={{
                fontSize: "16px",
                color: profileActive ? "#0066CC" : "#4A4F63",
                marginLeft: "auto",
                flexShrink: 0,
                transform: profileOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform .2s ease",
              }}
            >
              expand_more
            </i>
          </div>

          <div className={`lsb-sub ${profileOpen ? "open" : ""}`}>
            <Link
              className={`lsb-subitem${location.pathname === "/gateway-manage" ? " active" : ""}`}
              to="/gateway-manage"
              onClick={onNavClick}
            >
              Gateway Setting
            </Link>
            
            <Link
              className={`lsb-subitem${location.pathname === "/profile-manage" ? " active" : ""}`}
              to="/profile-manage"
              onClick={onNavClick}
            >
              Profile Setting
            </Link>
            <Link
              className={`lsb-subitem${location.pathname === "/password-manage" ? " active" : ""}`}
              to="/password-manage"
              onClick={onNavClick}
            >
              Password Manage
            </Link>
            <Link
              className={`lsb-subitem${location.pathname === "/tpin-manage" ? " active" : ""}`}
              to="/tpin-manage"
              onClick={onNavClick}
            >
              Trans Pin Manage
            </Link>
          </div>

        </div>

        {/* Logout */}
        <div className="lsb-footer">
          <button className="lsb-logout" onClick={logoutUser}>
            <i className="material-icons" style={{ fontSize: "16px", color: "#E8380A" }}>logout</i>
            <span>Log Out</span>
          </button>
        </div>

      </div>
    </>
  );
};

export default LeftSidebar;
